{
  "AlarmonnewabandonedcallLabel": "Alarm bei neuem abgebrochenem Anruf:",
  "NAME": "AbandonedCallAlarm",
  "AbandonedCallAlarm_SectionHeader": "Alarm für abgebrochene Anrufe",
  "AbandonedCallAlarm_SectionPara": "Sie können einen Alarm aktivieren, wenn neue abgebrochene Anrufe eingehen."
}